<template>
  <div class="search-form">
    <form @submit.prevent="search" method="get" accept-charset="utf-8" :action="url">
      <input type="hidden" id="search-input" name="Search" />
      <div class="form-row">
        <div class="col-12 col-lg-3 col-xl-5">
          <div class="input-group">
            <input type="text" class="form-control" :placeholder="l10n.placeholder" v-model.trim="searchString" :aria-label="l10n.placeholder" aria-describedby="search-icon-append" />
           <!-- <div class="input-group-append">
              <span class="input-group-text" id="search-icon-append">
                <i class="far fa-search"></i>
              </span>
            </div> -->
          </div>
        </div>

        <template v-for="fieldMap in fieldList">

        <div v-if="fieldMap[1].type === 'list'" :key="fieldMap[0]" class="col-12 col-lg-auto">
          <search-dropdown v-model="$store.state.selected[fieldMap[0]]" :field="fieldMap[0]" :label="fieldMap[1].display" :values="fieldMap[1].vals" :minWidth="minWidth"></search-dropdown>
        </div>

        <div v-else-if="fieldMap[1].type === 'tree'" :key="fieldMap[0]" class="col-12 col-lg-auto">
          <div v-if="isWide" class="dropdown">
            <button class="btn btn-outline-primary dropdown-toggle" type="button" id="dropdown-menu-types" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ fieldList["Types.id"] }}
              <font-awesome-icon :icon="['far', 'chevron-down']"></font-awesome-icon>
              <font-awesome-icon :icon="['far', 'chevron-up']"></font-awesome-icon>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdown-menu-types">
              <form>
                <tree-picker :tree="this.fieldValues['Types.id']" prefix="types"></tree-picker>
              </form>
            </div>
          </div>
          <template v-else>
            <div class="card">
              <div class="card-header" :id="'search-heading-' + 'types'">
                <h2 class="mb-0">
                  <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" :data-target="'#search-content-' + 'types'" aria-expanded="true" :aria-controls="'search-content-' + 'types'">
                    {{ fieldList["Types.id"] }}
                    <font-awesome-icon :icon="['far', 'chevron-down']"></font-awesome-icon>
                    <font-awesome-icon :icon="['far', 'chevron-up']"></font-awesome-icon>
                  </button>
                </h2>
              </div>

              <div :id="'search-content-types'" class="collapse" :aria-labelledby="'search-heading-types'">
                <div class="card-body">
                  <div class="form-group text-left">
                    <tree-picker :tree="this.fieldValues['Types.id']" prefix="types"></tree-picker>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        </template>


        <div class="col-12 col-lg-auto">
          <button id="search_button" class="btn btn-search" type="submit">
            {{ l10n.search }}
          </button>
          <slot></slot>
        </div>
      </div>

      <hr v-if="tags.length" />

      <div class="form-row">
        <div class="col search-tags">
          <button v-if="tags.length" class="btn btn-outline-primary" type="button" v-on:click="reset">
            {{ l10n.reset }}
            <font-awesome-icon :icon="['far', 'undo']" flip="horizontal"></font-awesome-icon>
          </button>
          <button v-for="tag in tags" :key="tag.uid" class="btn btn-primary" type="button" v-on:click="removeTag(tag)">
            {{ tag.item.name }}
            <font-awesome-icon :icon="['far', 'times']" size="lg"></font-awesome-icon>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSearch as faSearchRegular, faTimes as faTimesRegular, faUndo as faUndoRegular, faChevronDown as faChevronDownRegular, faChevronUp as faChevronUpRegular } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import TreePicker from "./TreePicker.vue";
import SearchDropdown from "./SearchDropdown.vue";
import { FieldInfo } from "./classes";

library.add(faSearchRegular, faTimesRegular, faUndoRegular, faChevronDownRegular, faChevronUpRegular);

export default {
  name: "SearchWidget",
  props: {
    l10n: {
      type: Object,
      required: true
    },
    fields: {
      type: Array,
      //required: true
    },
    modelName: {
      type: String
    },
    placeholder: {
      type: String,
      default: "--"
    },
    url: {
      type: String,
      required: true
    },
    searchData: {
      type: Array
    },
    minWidth: {
      type: Number,
      default: 992
    }
  },
  data: function() {
    return {
      lastItem: null,
      searchString: "",
      isWide: window.innerWidth >= this.minWidth
    };
  },
  computed: {
    /*isAccessible: {
      get() {
        return this.$store.state.selected.is_accessible;
      },
      set(value) {
        this.updateBoolean("is_accessible", value);
      }
    }, */
    fieldList: function() {
      let fl = [...this.$store.state.fields];
      if (!!this.$store.state.fields.get('all')) {
        fl.shift();
      }
     // console.log(fl);
      return fl;
    },
    tags: {
      get() {
        return this.$store.state.tags;
      }
    }
  },
  created: function() {
    this.$store.commit("model", this.model);
    this.$store.commit("l10n", this.l10n);
    this.$store.commit("fields", this.fields);
    this.$store.state.placeholder = this.placeholder;
    this.initData();
    window.addEventListener("resize", this.onWindowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);
  },

  methods: {
    getSelected: function(field) {
      return this["selected" + field.charAt(0).toUpperCase() + field.slice(1)];
    },
    setLastItem: function(item) {
      this.lastItem = item;
    },
    updateBoolean: function(field, value) {
      this.$store.commit("updateBoolean", {
        field: field,
        value: value
      });
    },
    removeTag: function(tag) {
      if (!tag.item.id) {
        this.updateBoolean(tag.field, false);
        return;
      }
      let selected = [...this.$store.state.selected[tag.field]];
      let i = selected.indexOf(parseInt(tag.item.id));
      if (i !== -1) {
        selected.splice(i, 1);
        this.$store.commit("updateSelected", {
          field: tag.field,
          value: selected,
          item: tag.item,
          path: tag.path
        });
      }
    },
    reset: function() {
      this.$store.commit("removeSelected");
    },
    search: function(e) {
      let searchData = [];
      let searchMap = new Map();

      if (this.searchString !== "") {
        searchData.push({ f: "all", q: this.searchString });
      }

      this.$store.state.tags.forEach(tag => {
        if (!tag.item.id) {
          searchData.push({ f: tag.field, q: 1 });
          return;
        }
        let cur = searchMap.get(tag.field);
        if (typeof cur === "undefined") {
          cur = [];
        }
        cur.push(parseInt(tag.item.id));
        searchMap.set(tag.field, cur);
      });
      //console.log(searchMap);
      searchMap.forEach((vals, field) => {
        let data = vals.map(id => {
          return { f: field, q: id };
        });

        //  if (field == "cycles") {
        // AND
        //    searchData.push({ and: data });
        //  } else {
        searchData.push({ or: data });
        //  }
      });
      //console.log(searchData);

      e.target.elements.Search.value = JSON.stringify(searchData);
      e.target.submit();
    },
    initData: function() {
      this.searchData.forEach(value => {
        if (typeof value === "undefined") {
          return;
        }
        let lines = [];
        //console.log(typeof value);
        if (!!value.and) {
          lines = value.and;
        } else if (!!value.or) {
          lines = value.or;
        } else if (!!value.f) {
          if (value.f === "all") {
            this.searchString = value.q;
          } else if (value.f === "is_accessible") {
            this.updateBoolean(value.f, true);
          }
        }
        lines.forEach(datum => {
          //let key = datum.f.split(".")[0].toLowerCase();
          //console.log(key);
          this.$store.commit("addSelected", {
            field: datum.f,
            key: datum.f,
            id: datum.q
          });
        });
      });
    },
    onWindowResize: function(e) {
      $("#dropdown-menu-types, #dropdown-menu-others").dropdown("hide");
      this.isWide = window.innerWidth >= this.minWidth;
    }
  },
  components: {
    FontAwesomeIcon,
    TreePicker,
    SearchDropdown
    // Dropdown
  }
};
</script>

